<ng-container *ngIf="{ isPresentationMode: isPresentationMode$ | async } as userConfig">
  <header class="alc-page-header" [ngClass]="{ 'presentation-mode': userConfig.isPresentationMode }">
    <nav class="layout nav-layout">
      <div class="logo">
        <a class="logo-link" routerLink="/dashboard">
          <img
            src="{{ userConfig.isPresentationMode ? darkModeLogoPath : defaultLogoPath }}"
            width="77px"
            height="34px"
            alt="Home"
          />
        </a>
      </div>
      <ul class="pages-list">
        <li class="page-title" *ngFor="let navItem of navigationLinks">
          <a
            class="nav-link"
            [routerLink]="[navItem.route]"
            [class.nav-link-active]="
              (isAccountsActiveUrl && isAccountsLink(navItem)) || (isAdminActiveUrl && isAdminLink(navItem))
            "
            [routerLinkActive]="isAccountsLink(navItem) || isAdminLink(navItem) ? '' : 'nav-link-active'"
            (click)="onNavItemClick(navItem.route)"
          >
            {{ navItem.title | transloco }}
          </a>
        </li>
      </ul>
      <div class="search-container">
        <cpak-search [isPresentationMode]="!!userConfig.isPresentationMode"></cpak-search>
      </div>
      <ul class="personal-actions">
        <li class="personal-action presentation-toggle">
          <button
            (click)="onPresentationModeClick()"
            pButton
            type="button"
            label="{{ userConfig.isPresentationMode ? ('presenting' | transloco) : '' }}"
            icon="{{
              userConfig.isPresentationMode ? 'alc-icon-presentation-mode-dark-mode' : 'alc-icon-presentation-mode'
            }}"
            class="p-button-text alc-custom-text-button presentation-button"
            [cpakTrackClick]="ButtonNamesGA.PresentationMode"
          ></button>
        </li>

        <li class="personal-action">
          <button
            (click)="onChatClick()"
            pButton
            type="button"
            label="{{ userConfig.isPresentationMode ? ('' | transloco) : '' }}"
            icon="{{ userConfig.isPresentationMode ? 'alc-icon-chat-dark-mode' : 'alc-icon-chat' }}"
            class="p-button-text alc-custom-text-button chat-button"
          ></button>
        </li>

        <li class="personal-action notification-icon-wrapper" *ngIf="isInAppNotificationsEnabled$ | async">
          <p-button
            icon="{{ userConfig.isPresentationMode ? 'alc-icon-notification-dark-mode' : 'alc-icon-notification' }}"
            class="notification-icon-button"
            badgeClass="p-badge-danger"
            badge="{{ (countOfUnreadNotifications$ | async) || null }}"
            (click)="openNotificationPopover($event)"
            [cpakTrackClick]="ButtonNamesGA.NotificationBell"
          ></p-button>
        </li>
        <li class="personal-action">
          <button
            pButton
            type="button"
            icon="{{ userConfig.isPresentationMode ? 'alc-icon-profile-dark-mode' : 'alc-icon-profile' }}"
            class="p-button-text alc-custom-text-button"
            (click)="toggleMenu($event)"
          ></button>
        </li>
      </ul>
    </nav>
    <p-menu
      #headerMenu
      styleClass="menu-with-right-cursor"
      [popup]="true"
      [model]="menuConfig | trackedMenuItems"
      appendTo="body"
    ></p-menu>
  </header>
  <div class="substrate"></div>
  <cpak-notifications-popover
    [notifications]="(inAppNotifications$ | async)!"
    *ngIf="isInAppNotificationsEnabled$ | async"
  >
  </cpak-notifications-popover>
</ng-container>
